module.exports = __webpack_public_path__ + "static/media/notes.7781e188.svg";